module.exports = __webpack_public_path__ + "media/assets_v3/images/dolandirici_dikkat-f5789306881509272e6a08cc87458e84.jpg";